<div class="send-krc20-content">
  <!-- Token Info Header -->
  <div class="token-info-header card-0 flex align-items-center gap-16 p-16">
    <kc-token-logo
      [ticker]="token()?.symbol || ''"
      [address]="token()?.address || ''"
      [size]="'lg'"
    />
    <div class="flex column gap-4">
      <div class="text-gray-90 typo-text-2">
        {{ token()?.name | titlecase }}
      </div>
      <div class="text-gray-60 typo-text-1">
        Available: {{ availableBalance }}&nbsp;{{ token()?.symbol | uppercase }}
      </div>
    </div>
  </div>

  <div class="send-krc20-form">
    <!-- Wallet Address Input -->
    <div class="form-field">
      <app-address-smart-input
        [label]="'Wallet Address'"
        [placeholder]="'Enter recipient wallet address'"
        [isFullWidth]="true"
        [isValid]="isAddressValid"
        [invalidReason]="addressErrorMessage"
        [isDisabled]="isLoading"
        [value]="walletAddress"
        (valueChange)="onWalletAddressChange($event)"
        (qrClick)="onQrScanClick()"
      />
    </div>

    <!-- Amount Input -->
    <div class="form-field">
      <kc-number-input
        [infoLabel]="{ label: 'Amount of ' + (token()?.symbol | uppercase) }"
        [placeholder]="'0.00'"
        [token]="$any(token())"
        [available]="availableBalance.toString()"
        [isValid]="isAmountValid"
        [isDisabled]="isLoading"
        [ngModel]="tokenAmount"
        (valueChange)="onAmountChange($event)"
      >
        <div
          (click)="!isLoading && onMaxAmountClick()"
          [class]="isLoading ? 'max-text disabled' : 'max-text clickable'"
          rightSideSlot
        >
          <span>Max</span>
        </div>
      </kc-number-input>
      @if (!isAmountValid && amountErrorMessage) {
        <span class="kc-input-error-text">{{ amountErrorMessage }}</span>
      }
    </div>

    <!-- Send Button -->
    <div class="form-field">
      <kc-button
        [text]="
          isLoading
            ? 'Sending...'
            : 'Send ' +
              (token()?.symbol ? (token()?.symbol | uppercase) : 'Token')
        "
        [variant]="'primary'"
        [isFullWidth]="true"
        [isLoading]="isLoading"
        [isDisabled]="!isFormValid"
        (buttonClick)="onSendClick()"
      />
    </div>
  </div>
</div>
